import { setup, assign } from "xstate";
import type { Direction, Position } from "@engine/types/grid.js";

interface PlayerContext {
  position: Position;
  facing: Direction;
  hp: number;
  maxHp: number;
}

type PlayerEvent =
  | { type: "MOVE"; target: Position }
  | { type: "ROTATE"; facing: Direction }
  | { type: "TAKE_DAMAGE"; amount: number }
  | { type: "HEAL"; amount: number }
  | { type: "ANIMATION_COMPLETE" }
  | { type: "ENTER_COMBAT" }
  | { type: "EXIT_COMBAT" };

export const playerMachine = setup({
  types: {
    context: {} as PlayerContext,
    events: {} as PlayerEvent,
    input: {} as PlayerContext,
  },
}).createMachine({
  id: "player",
  initial: "idle",
  context: ({ input }) => input,
  states: {
    idle: {
      on: {
        MOVE: { target: "moving", actions: assign({ position: ({ event }) => event.target }) },
        ROTATE: { target: "rotating", actions: assign({ facing: ({ event }) => event.facing }) },
        ENTER_COMBAT: "combat",
        TAKE_DAMAGE: {
          actions: assign({
            hp: ({ context, event }) => Math.max(0, context.hp - event.amount),
          }),
          target: "checkDead",
        },
      },
    },
    moving: {
      on: {
        ANIMATION_COMPLETE: "idle",
      },
    },
    rotating: {
      on: {
        ANIMATION_COMPLETE: "idle",
      },
    },
    combat: {
      on: {
        EXIT_COMBAT: "idle",
        MOVE: { target: "moving", actions: assign({ position: ({ event }) => event.target }) },
        ROTATE: { target: "rotating", actions: assign({ facing: ({ event }) => event.facing }) },
        TAKE_DAMAGE: {
          actions: assign({
            hp: ({ context, event }) => Math.max(0, context.hp - event.amount),
          }),
          target: "checkDead",
        },
        HEAL: {
          actions: assign({
            hp: ({ context, event }) => Math.min(context.maxHp, context.hp + event.amount),
          }),
        },
      },
    },
    checkDead: {
      always: [
        { guard: ({ context }) => context.hp <= 0, target: "dead" },
        { target: "combat" },
      ],
    },
    dead: {
      type: "final",
    },
  },
});
